







  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';

  /**
   * Renders a transition wrapping the element passed in the default slot. The animation just fades
   * in/out the element by changing its opacity.
   *
   * @public
   */
  @Component({
    inheritAttrs: false
  })
  export default class Fade extends Vue {
    /**
     * Indicates if the transition must be applied on the initial render of the node.
     */
    @Prop({
      type: Boolean,
      default: true
    })
    public appear!: boolean;
  }
